import React, { useContext } from 'react';
import classnames from 'classnames';
import { URLS, Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import CoreStar from '@wix/da-ds/pkg/Icons/CoreStar';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import { useCurrentPromo } from '../../../utils/hooks/useCurrentPromo';
import StandardMenu from '../../../Dropdown/MenuPreset/StandardMenu';
import SaleBanner from '../../../SaleBanner';
import MenuList from '../../../Dropdown/MenuList';
import { getMatureToggle, getThemeToggle } from './menuItemHelpers';
import UserMenuAvatar from './UserMenuAvatar';
import userMenuStyles from './UserMenu.scss';
var LoggedOutUserMenu = function (_a) {
    var isUserMenuOpened = _a.isUserMenuOpened, onToggleUserMenu = _a.onToggleUserMenu, toggleMature = _a.toggleMature, toggleTheme = _a.toggleTheme, disableThemeSwitcher = _a.disableThemeSwitcher;
    var t = useTranslation().t;
    var currentPromo = useCurrentPromo('self');
    var theme = useContext(ThemeContext);
    var matureContent = useContext(MatureContext);
    var ds_user_dropdown = useFlag('ds_user_dropdown');
    var MenuComponent = ds_user_dropdown ? MenuList : StandardMenu;
    var tabIndex = isUserMenuOpened ? 0 : -1;
    var items = [
        {
            className: userMenuStyles['top-group'],
            items: [
                {
                    label: (React.createElement("div", { className: userMenuStyles['two-side-label'] },
                        React.createElement("span", { className: userMenuStyles['anon-hello'] }, t('siteHeaderMobile.userMenu.hello')),
                        React.createElement(UserMenuAvatar, { onToggleUserMenu: onToggleUserMenu, isUserMenuOpened: isUserMenuOpened, tabIndex: tabIndex }))),
                },
            ],
        },
        {
            className: userMenuStyles['group'],
            items: [
                {
                    label: t('siteHeaderMobile.userMenu.signIn'),
                    link: Url.loginLink(),
                    biData: BiData({
                        evid: 702,
                        link_url: Url.loginLink(),
                        menu_item: 'login',
                        menu_name: 'profile',
                    }),
                    tabIndex: tabIndex,
                },
                {
                    label: t('siteHeaderMobile.userMenu.join'),
                    link: Url.joinLink(),
                    biData: {
                        evid: BiEventType.REDIRECT_TO_LOGIN,
                        referral_info: ReferralType.HEADER,
                    },
                    tabIndex: tabIndex,
                },
                {
                    label: (React.createElement("div", { className: classnames(userMenuStyles['two-side-label'], userMenuStyles['buy-core-label']) },
                        React.createElement("span", null, t('siteHeaderMobile.userMenu.buyCoreMembership')),
                        React.createElement("span", null,
                            React.createElement(CoreStar, { className: userMenuStyles['core-icon'], size: IconSize.SMALL })))),
                    link: URLS.CORE_MEMBERSHIP,
                    biData: BiData({
                        evid: 702,
                        link_url: URLS.CORE_MEMBERSHIP,
                        menu_item: 'core_membership',
                        menu_name: 'profile',
                    }),
                    tabIndex: tabIndex,
                },
                currentPromo && {
                    complexLabel: (React.createElement(SaleBanner, { className: userMenuStyles['sale-banner'], isNarrow: true, endDate: currentPromo.endDate, discountValuePercent: currentPromo.discountValuePercent, referralType: ReferralType.PROMOTION_BANNER_USERMENU })),
                },
                !disableThemeSwitcher && getThemeToggle(theme, toggleTheme, t),
                getMatureToggle(!!matureContent, toggleMature, t),
            ],
        },
        {
            className: userMenuStyles['group'],
            items: [
                {
                    label: t('siteHeader.userMenu.helpAndFAQ'),
                    link: URLS.HELP,
                    biData: BiData({
                        evid: 702,
                        link_url: URLS.HELP,
                        menu_item: 'help',
                        menu_name: 'profile',
                    }),
                    tabIndex: tabIndex,
                },
                {
                    label: t('siteHeader.userMenu.termsOfService'),
                    link: URLS.TOS,
                    biData: BiData({
                        evid: 702,
                        link_url: URLS.TOS,
                        menu_item: 'tos',
                        menu_name: 'profile',
                    }),
                    tabIndex: tabIndex,
                },
                {
                    label: t('siteHeader.userMenu.privacyPolicy'),
                    link: URLS.PRIVACY,
                    biData: BiData({
                        evid: 702,
                        link_url: URLS.PRIVACY,
                        menu_item: 'privacy_policy',
                        menu_name: 'profile',
                    }),
                    tabIndex: tabIndex,
                },
            ],
        },
    ].filter(function (item) { return item; });
    return (React.createElement(MenuComponent, { id: "site-header-user-menu", role: "dialog", lightText: true, className: classnames(userMenuStyles['user-menu'], ds_user_dropdown && userMenuStyles['ds_user_dropdown']), itemsFillContainerWidth: true, itemClassName: userMenuStyles['user-menu-item'], groupClassName: userMenuStyles['user-menu-group'], items: items }));
};
LoggedOutUserMenu.displayName = 'LoggedOutUserMenu';
export default LoggedOutUserMenu;
//# sourceMappingURL=LoggedOutUserMenu.js.map